import { Button } from "@src/appV2/redesign/components/Button";
import { PageFooterWrapper } from "@src/appV2/redesign/components/PageFooterWrapper";

import { BadgeStep, BUTTON_LABELS } from "../constants";
import type { StepProps } from "../types";

interface StepFooterProps extends StepProps {
  selectedQualificationHasMultipleLicenses?: boolean;
  isLoadingQualifications?: boolean;
}

export function StepFooter({
  state,
  actions,
  selectedQualificationHasMultipleLicenses = false,
  isLoadingQualifications = false,
}: StepFooterProps) {
  const getButtonConfig = () => {
    switch (state.currentStep) {
      case BadgeStep.INFO: {
        return {
          label: BUTTON_LABELS.VIEW_BADGE,
          onClick: actions.handleViewBadge,
          disabled: isLoadingQualifications,
        };
      }

      case BadgeStep.QUALIFICATION_SELECTION: {
        return {
          label: selectedQualificationHasMultipleLicenses
            ? BUTTON_LABELS.CONTINUE
            : BUTTON_LABELS.VIEW_BADGE,
          onClick: actions.handleContinueFromQualification,
          disabled: !state.selectedQualificationId,
        };
      }

      case BadgeStep.STATE_SELECTION: {
        return {
          label: BUTTON_LABELS.VIEW_BADGE,
          onClick: actions.handleContinueFromState,
          disabled: !state.selectedLicenseId,
        };
      }

      default: {
        state.currentStep satisfies never;
        return null;
      }
    }
  };

  const buttonConfig = getButtonConfig();
  // This should always be defined, but we need to satisfy the type checker
  if (!buttonConfig) {
    return null;
  }

  return (
    <PageFooterWrapper>
      <Button
        fullWidth
        variant="contained"
        disabled={buttonConfig.disabled}
        onClick={async () => {
          await buttonConfig.onClick();
        }}
      >
        {buttonConfig.label}
      </Button>
    </PageFooterWrapper>
  );
}
